<template>
    <el-container class="bg-white">
        <el-header style="padding: 0px; height: auto; ">
            <!-- title部 -->
            <div class="flex justify-between items-center h-20 border-b border-b-gray-800">
                <!-- logo部 -->
                <a href="#" class="flex items-center ml-4">
                    <img src="/symbol_72px.png" alt="logo" style="width: 48px; height: 48px;">
                    <span class="ml-4 font-bold text-2xl">HEAT AID</span>
                </a>

                <!-- logout部 -->
                <el-button link @click="logout" class="mr-2">
                    <el-icon :size="30">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" id="body_1"
                            width="100%" height="100%" style="display: block; margin: auto;">
                            <g>
                                <image x="0" y="0"
                                    xlink:href="data:image/png;base64,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"
                                    preserveAspectRatio="none" width="100%" height="100%" />
                            </g>
                        </svg>
                    </el-icon>
                </el-button>
            </div>
        </el-header>

        <el-container style="height: calc(100vh - 80px)">
            <!-- 左菜单 -->
            <el-aside :style="{ width: isCollapse ? '80px' : '240px' }" style="overflow-x: hidden;">
                <el-menu :default-active="defaultActive" :default-openeds="['System']" class="el-menu-vertical-demo shadow-md" :collapse="isCollapse"
                    active-text-color="#409EFF" style="height: calc(100vh - 80px) "
                    >
                    <el-menu-item :index="ROUTES.DASHBOARD" @click="router.push(`/${ROUTES.DASHBOARD}`)">
                        <el-icon>
                            <Document />
                        </el-icon>
                        <template #title>ダッシュボード</template>
                    </el-menu-item>

                    <el-sub-menu index="System">
                        <template #title>
                            <el-icon>
                                <Setting />
                            </el-icon>
                          <span>システム管理</span>
                        </template>
                        <el-menu-item :index="ROUTES.MNT_COMPANY" v-if="[ROLES.SYSTEM].includes(loginUserRole)" @click="router.push(`/${ROUTES.MNT_COMPANY}`)">
                            契約会社管理
                        </el-menu-item>
                        <el-menu-item :index="ROUTES.MNT_USER" v-if="[ROLES.SYSTEM, ROLES.ADMIN].includes(loginUserRole)" @click="router.push(`/${ROUTES.MNT_USER}`)">
                            安全責任者管理
                        </el-menu-item>
                        <el-menu-item :index="ROUTES.MNT_SITE" @click="router.push(`/${ROUTES.MNT_SITE}`)">
                            現場管理
                        </el-menu-item>
                        <el-menu-item :index="ROUTES.MNT_SENSOR" v-if="[ROLES.SYSTEM, ROLES.ADMIN].includes(loginUserRole)" @click="router.push(`/${ROUTES.MNT_SENSOR}`)">
                            センサー管理
                        </el-menu-item>
                        <el-menu-item :index="ROUTES.MNT_OPERATOR" v-if="[ROLES.SYSTEM].includes(loginUserRole)" @click="router.push(`/${ROUTES.MNT_OPERATOR}`)">
                             作業員（端末）参照
                        </el-menu-item>
                        <el-menu-item :index="ROUTES.ENV_SETTINGS" v-if="[ROLES.SYSTEM].includes(loginUserRole)" @click="router.push(`/${ROUTES.ENV_SETTINGS}`)">
                            環境設定
                        </el-menu-item>
                    </el-sub-menu>

                    <el-menu-item :index="ROUTES.PERSONAL_SETTINGS" @click="router.push(`/${ROUTES.PERSONAL_SETTINGS}`)">
                        <el-icon>
                            <Avatar />
                        </el-icon>
                        <template #title>個人設定</template>
                    </el-menu-item>
                </el-menu>
            </el-aside>

            <!-- 主显示 -->
            <el-main style="padding: 0px;" :style="{ width: isCollapse ? 'calc(100% - 80px)' : 'calc(100% - 240px)' }">
                <router-view />
            </el-main>
        </el-container>

    </el-container>
</template>

<script lang="ts">
import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
import {
  Avatar,
  Setting,
  Document,
} from '@element-plus/icons-vue'
import { Action, ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';
import { authService } from '@/services/authService';
import { ROUTES, ROLES } from '@/config/constants';

export default defineComponent({
  name: 'MainLayout',
  components: {
    Setting,
    Avatar,
    Document,
  },
  setup() {
    const defaultActive = ref<string>(ROUTES.DASHBOARD);
    const user_name = ref<string>('');
    const isCollapse = ref(false);

    const loginUserRole = authService.getUserInfo().user_role ?? '';

    const updateCollapse = () => {
      isCollapse.value = window.innerWidth < 992; // 根据屏幕宽度设置缩进
    }

    onMounted(() => {
      const path = router.currentRoute.value.path.replace(/^\/|\/$/g, '');
      const allowedPaths = [
        ROUTES.MNT_COMPANY, 
        ROUTES.MNT_USER, 
        ROUTES.MNT_SITE, 
        ROUTES.MNT_SENSOR, 
        ROUTES.MNT_OPERATOR,
        ROUTES.ENV_SETTINGS, 
        ROUTES.PERSONAL_SETTINGS,
      ];
      if(allowedPaths.includes(path)){
        defaultActive.value = path;
      }else{
        defaultActive.value = ROUTES.DASHBOARD;
      }

      const user = authService.getUserInfo().user_name;
      if (user) {
        user_name.value = user;
      }

      updateCollapse(); // 初始化时检查宽度
      window.addEventListener('resize', updateCollapse); // 监听窗口大小变化
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', updateCollapse); // 移除事件监听器
    });

    const toggleCollapse = () => {
      isCollapse.value = !isCollapse.value;
    }
    
    /**
     * ログアウト
     */
    const logout = () => {
      ElMessageBox.confirm('ログアウトしますか？', '確認', {
        confirmButtonText: 'OK',
        callback: (action: Action) => {

          if (action === 'confirm') {
            authService.removeUserInfo();

            router.push(`/${ROUTES.LOGIN}`);
            // eventBus.emit('userLoggedOut'); // 触发退出事件
            ElMessage.info(`ログアウトしました！`)

          }
        }
      })
    }




    return {
      router,
      loginUserRole,
      user_name,
      toggleCollapse,
      isCollapse,
      logout,
      defaultActive,
      ROUTES,
      ROLES
    }
  },
});
</script>
<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
}
</style>

<!-- <style scoped>
.el-menu-item:hover {
  background-color: #409EFF;
  color: #fff;
}

::v-deep .el-sub-menu__title:hover {
  background-color: #409EFF;
}
</style> -->